module.exports = __webpack_public_path__ + "static/media/workshop_img.d566f90d.jpg";